import axiosLogin from "global/helpers/axiosLogin";
import { SET_IDTIPO_PUNTOCONTROL } from "../ActionTypes";

export const wsPostTrazaPuntoControl = (dto) => (nextStep) => {
  axiosLogin().then((respuesta) => {
    respuesta
      .post("/shared/puntocontrol", dto)
      .then((resp) => {
        if (nextStep) nextStep(true, resp);
      })
      .catch((err) => {
        if (nextStep) nextStep(true, err);
      });
  });
};

// `mensajeError` es opcional. Cuando viene, se muestra como detalle en
// PuntoControl (por ejemplo, el mensaje del endpoint que rechazó).
export const setIdTipoPuntoControl =
  (idTipo, mensajeError = null) =>
  (dispatch) => {
    dispatch({
      type: SET_IDTIPO_PUNTOCONTROL,
      payload: { idTipo, mensajeError },
    });
  };

export const resetIdTipoPuntoControl = () => (dispatch) => {
  dispatch({
    type: SET_IDTIPO_PUNTOCONTROL,
    payload: { idTipo: null, mensajeError: null },
  });
};

export const wsGetPuntoControlTexto =
  (idTipo, idRecepcion, idCentro) => (nextStep) => {
    axiosLogin().then((respuesta) => {
      respuesta
        .get(`/shared/puntocontrol/texto/${idTipo}/${idRecepcion}/${idCentro}`)
        .then((resp) => {
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          if (nextStep) nextStep(true, err);
        });
    });
  };